import { logFetchError } from "src/auth/utils/log";
import type { Mode } from "../../utils/types/mode";

const PARTNER_NAME = "rome2rio";

type BaseEvent = {
  origin?: string;
  destination?: string;
};

type TransportEvent = BaseEvent & {
  travelMode?: Mode;
  outBoundDate?: string;
  inBoundDate?: string;
  passengerCount?: number;
};

type TransportSearch = TransportEvent & {
  event: "transportSearch";
  travelCarriers: string[];
  languageCode?: string;
  currencyCode?: string;
  uid?: string;
  uidCookie?: string;
  price?: string;
  currency?: string;
  dataSource?: "dp";
  level?: number;
  account?: "RTR";
  path?: string;
  oneWay?: boolean;
  mai?: string;
  mat?: string;
  operator?: string;
  departureAirport?: string;
  destinationAirport?: string;
  adultPassengers?: number;
  childPassengers?: number;
  airlineCode?: string;
};

type TransportExit = TransportEvent & {
  event: "transportExit";
  ticketCarriers?: string[];
  totalPrice?: string;
};

type HotelExit = BaseEvent & {
  event: "hotelExit";
  hotelName?: string;
  checkinDate?: Date;
  checkoutDate?: Date;
};

type CarHireExit = BaseEvent & {
  event: "carHireExit";
};

type StackAdaptPixelProps =
  | TransportSearch
  | TransportExit
  | HotelExit
  | CarHireExit;

export function sendStackAdaptPixel(event: StackAdaptPixelProps) {
  const baseUrl = `https://integration.srv.stackadapt.com/vertical/travel/${PARTNER_NAME}`;

  const serializedEvent: Record<string, string> = {};

  for (const [key, value] of Object.entries(event)) {
    if (value !== undefined && value !== null) {
      if (value instanceof Date) {
        serializedEvent[key] = value.toISOString().split("T")[0];
      } else {
        serializedEvent[key] = String(value);
      }
    }
  }

  const queryParams = new URLSearchParams(serializedEvent).toString();
  const pixelUrl = `${baseUrl}?${queryParams}`;

  fetch(pixelUrl, {
    method: "GET",
    mode: "no-cors",
  }).catch((error) => {
    logFetchError(error);
    throw error;
  });
}
